import React, { PureComponent } from "react";
import { Loading } from "./loading";
import classNames from "../../utils/classnames";

export class Loadmore extends PureComponent {
  render() {
    const { children, className, loading, line, dot, ...others } = this.props;
    const cls = classNames({
      "weui-loadmore": true,
      "weui-loadmore_line": !loading && line,
      "weui-loadmore_dot": dot
    }, className);

    return <div className={ cls } { ...others }>
      { loading && <Loading primary /> }
      { dot && <div className="weui-hidden_abs">已无更多数据</div> }
      <span className="weui-loadmore__tips">{ !dot && children }</span>
    </div>;
  }
}
